import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Icon, InputText } from 'components';
import { IInputProps } from 'modules';
import { toast } from 'react-hot-toast';
import './BidvVaInput.scss';

const CopyToClipboardElement = CopyToClipboard as any;

type BidvVaInputProps = IInputProps & {
  vaPrefix: string;
  prefixWidth?: React.CSSProperties['width'];
};

export const BidvVaInput = ({
  vaPrefix,
  prefixWidth = 150,
  ...props
}: BidvVaInputProps) => {
  const fullVa = `${vaPrefix}${props.value ?? ''}`;
  const canCopy = Boolean(vaPrefix && props.value);

  return (
    <>
      <input
        className='bidv-va-prefix'
        style={{ width: prefixWidth }}
        aria-label='vaPrefix BIDV'
        title={vaPrefix || 'Company chưa có mã đầu tiểu khoản BIDV'}
        value={vaPrefix}
        readOnly
      />
      <InputText {...props} aria-label='VA BIDV' placeholder='Nhập VA' />
      <CopyToClipboardElement
        text={fullVa}
        onCopy={(_text: string, result: boolean) => {
          if (result) {
            toast.success('Đã sao chép');
          } else {
            toast.error('Không thể sao chép tiểu khoản BIDV');
          }
        }}
      >
        <button
          type='button'
          className='bidv-va-copy'
          aria-label='Sao chép tiểu khoản BIDV (prefix + VA)'
          title='Sao chép tiểu khoản BIDV (prefix + VA)'
          disabled={!canCopy}
        >
          <Icon.Copy />
        </button>
      </CopyToClipboardElement>
    </>
  );
};
